import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getBalance } from "../../utils/contractHelpers";
import { RAIN_ARBI_CONTRACT_ADDRESS, usdt_token } from "../../utils/Enviroment";
import { convertFromWei, convertFromWeiEthers } from "../../utils/helpers";
import { USDT_UNIT, RAIN_UNIT } from "../../utils/constants";

const useBalance = () => {
    const web3 = useWeb3();
    const tokenAddress = usdt_token;

    const BalanceHook = useCallback(
        async (account) => {
            const contract = getBalance(tokenAddress, web3);
            try {
                const balance = await contract.methods.balanceOf(account).call();
                const formattedBalance = convertFromWei(balance, USDT_UNIT);
                return formattedBalance;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, tokenAddress]
    );

    const getRainBalance = useCallback(
        async (address) => {
            const contract = getBalance(RAIN_ARBI_CONTRACT_ADDRESS, web3);
            try {
                const balance = await contract.methods.balanceOf(address).call();
                const formattedBalance = convertFromWei(balance, RAIN_UNIT);
                return formattedBalance;
            } catch (error) {
                console.error("Error fetching RAIN balance:", error.message || error);
                throw error;
            }
        },
        [web3]
    );

    const getTokenBalance = async (tokenAddress, walletAddress, tokenDecimals) => {
        try {
            const contract = getBalance(tokenAddress, web3);
            const balance = await contract.methods.balanceOf(walletAddress).call();
            const formattedBalance = convertFromWeiEthers(
                balance,
                tokenDecimals
            );
            return formattedBalance;
        } catch (error) {
            console.error("Error fetching RAIN balance:", error.message || error);
            throw error;
        }
    }

    return { BalanceHook, getRainBalance, getTokenBalance };
};

export default useBalance;
